import { 
    ChartBarIcon,
    TableCellsIcon,
    ViewfinderCircleIcon,
} from '@heroicons/react/24/outline';
import {
    Tabs, 
    Tab,
} from "@nextui-org/react";
import RootAdmin from "../../components/layouts/RootAdmin";
import Highcharts from "highcharts";
import highchartsExporting from 'highcharts/modules/exporting';
import OverviewChart from "../../components/fragments/admin/dashboard/general/OverviewChart";
import B3DistributionMap from "../../components/fragments/admin/dashboard/general/B3DistributionMap";
import B3Table from "../../components/fragments/admin/dashboard/general/B3Table";

highchartsExporting(Highcharts);

export default function DashboardPage() {
    return (
        <RootAdmin>
            <Tabs className="pt-3" color="primary" radius="sm" size="md" variant="bordered">
                <Tab key="overview" title={
                    <div className="flex items-center space-x-2">
                        <ChartBarIcon className="size-5"/>
                        <span className="mt-0.5">Umum</span>
                    </div>
                }>
                    <OverviewChart/>   
                </Tab>

                <Tab key="sebaran" title={
                    <div className="flex items-center space-x-2">
                        <ViewfinderCircleIcon className="size-5"/>
                        <span className="mt-0.5">Data Sebaran B3</span>
                    </div>
                }>
                    <B3DistributionMap/>
                </Tab>

                <Tab key="table" title={
                    <div className="flex items-center space-x-2">
                        <TableCellsIcon className="size-5"/>
                        <span className="mt-0.5">Tabel Data B3</span>
                    </div>
                }>
                    <B3Table/>
                </Tab>
            </Tabs>
        </RootAdmin>
    );
}